((app, ng) => {
    app.component("carrierMappings", {
        templateUrl: "/App/States/Carriers/Mappings/carrier.mappings.html",
        controller: carrierMappingsCtrl,
        bindings: {
            data: "<",
            mappedCarriers: "<",
            onReload: "&"
        }
    });

    carrierMappingsCtrl.$inject = ["$mdDialog", "carrierMappingApi", "$state"];
    function carrierMappingsCtrl($mdDialog, carrierMappingApi, $state) {
        var $ctrl = this;
        $ctrl.ui = {};

        $ctrl.openMapCarrier = (event, carrier, mappedCarriers) => {
            $mdDialog.show({
                locals: {
                    carrier: carrier,
                    mappedCarriers: mappedCarriers
                },
                controller: "mapCarrierCtrl",
                templateUrl: "/App/States/Modals/MapCarrier/map.carrier.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: false
            })
            .then((updates) => {
                if (updates) {
                    $ctrl.onReload();
                }
            });
        };

        $ctrl.getFileNames = function (unmappedCarrier) {
            $ctrl.ui.showFilesLoading = unmappedCarrier.FileGroupId;
            carrierMappingApi.getFileNames(unmappedCarrier.FileGroupId).then((names) => {
                unmappedCarrier.FileNames = names;
                $ctrl.ui.showFilesLoading = null;
            });
        };
    }

})(window.app, window.angular);
